function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.929 9.521L10 16.077 3.06 9.5l-.013-.013-.013-.012h-.001a7.672 7.672 0 01-.377-.374 9.113 9.113 0 01-.803-.986C1.266 7.28.75 6.224.75 5.132c0-1.449.446-2.52 1.186-3.23C2.679 1.187 3.808.75 5.335.75c.789 0 1.599.309 2.35.757a10.11 10.11 0 011.793 1.4l.522.506.522-.506a10.11 10.11 0 011.793-1.4c.751-.448 1.561-.757 2.35-.757 1.527 0 2.656.437 3.4 1.152.739.71 1.185 1.781 1.185 3.23 0 1.092-.516 2.147-1.104 2.986-.53.755-1.067 1.261-1.2 1.387a4.182 4.182 0 01-.017.016h0z",
  stroke: "#fff",
  strokeWidth: 1.5
});

function SvgSaved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSaved;